var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { Field } from "formik";
import Box from "@mui/material/Box";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import TableContainer from "@mui/material/TableContainer";
import { TableBodyWithScrollModal, } from "../../atoms/Table/TableBodyWithScroll";
import { TableHead, } from "../../atoms/Table/TableHead";
import { TableHeaderCellModal, } from "../../atoms/Table/TableHeaderCell";
import { TableBodyCellModal, } from "../../atoms/Table/TableBodyCell";
import { Delimiter } from "../../atoms/Delimiter";
import { setPlayersOrder } from "../../../api";
import { useErrorHandler } from "../../../hooks/useErrorHandler";
import { AlertsNew } from "../../molecules/Alerts/Alerts";
import { useAsyncExecAction } from "../../../hooks/useAsyncExecAction";
import { Table } from "@mui/material";
const StyledTableCell = styled(TableCell) `
  width: 150px;
  padding: 5px 16px !important;
`;
const commonModalStyles = {
    padding: "30px",
    maxHeight: "calc(100vh - 150px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
};
const Content = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const Title = styled.div `
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  //color: #000;
  color: #fff;
`;
const HeaderContainer = styled.div `
  display: flex;
  align-items: center;
`;
const OrderHint = styled.div `
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  //color: rgba(0, 0, 0, 0.8);
  color: #fff;
`;
const TableHeaderNumberCell = styled(TableHeaderCellModal) `
  width: 98px;
`;
const TableHeaderNameCell = styled(TableHeaderCellModal) `
  width: 218px;
`;
const TableHeaderGameNameCell = styled(TableHeaderCellModal) `
  width: 172px;
`;
const TableHeaderGamesCell = styled(TableHeaderCellModal) `
  width: 120px;
`;
const TableBodyNumberCell = styled(TableBodyCellModal) `
  width: 98px;
`;
const TableBodyNameCell = styled(TableBodyCellModal) `
  width: 218px;
`;
const TableBodyGameNameCell = styled(TableBodyCellModal) `
  width: 172px;
`;
const TableBodyGamesCell = styled(TableBodyCellModal) `
  width: 120px;
`;
const TableBody = styled(TableBodyWithScrollModal) `
  max-height: calc(100vh - 418px);
  left: 0;
  min-width: 100%;
`;
const InputWrapper = styled.div `
  position: relative;
  z-index: 10;
  margin-top: 19px;
`;
const Input = styled(Field) `
  width: 131px;
  height: 28px;
  padding: 0 12px 6px 0;
  background-color: transparent;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  //color: #000;
  color: #fff;
  transition: 0.3s;
  border: none;
  //border-bottom: 2px solid #000;
  border-bottom: 2px solid #fff;
  border-radius: 1px;
  outline: none;
  &:not(:placeholder-shown, :focus) {
    & + label {
      bottom: 100%;
      & + img {
        cursor: pointer;
        pointer-events: all;
        opacity: 1;
      }
    }
  }
  &:focus {
    //color: #ffd643;
    //border-bottom: 2px solid #ffd643;
    & + label {
      bottom: 100%;
    }
  }
  &:-webkit-autofill {
    transition: background-color 50000s ease-in-out 0s;
    //-webkit-text-fill-color: #ffd643 !important;
  }
`;
const Label = styled.label `
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: rgba(255, 255, 255, 0.7);
  position: absolute;
  width: 100%;
  bottom: 6px;
  left: 0;
  transition: 0.3s;
  z-index: -1;
  user-select: none;
`;
const CloseBtn = styled.img `
  position: absolute;
  right: 0;
  bottom: 11px;
  width: 10px;
  height: 10px;
  pointer-events: none;
  opacity: 0;
  transition: 0.3s;
`;
export function AjustPlayersOrder({ players, matchId, setPlayersChanged, onClose, }) {
    const [innerPlayers, setInnerPlayers] = useState(players);
    const [range, setRange] = useState([]);
    const [positions, setPositions] = useState([]);
    const [position, setPosition] = useState(range[0]);
    const { setError } = useErrorHandler();
    const { execAsyncAction } = useAsyncExecAction();
    const [infoAlert, setInfoAlert] = useState({
        message: "",
        type: "null",
        visible: false,
        setCancel: null,
    });
    // console.log('AdjustPlayersOrder', range)
    useEffect(() => {
        const r = Array.from(Array(players.length).keys()).map((k) => k + 1);
        // console.log('AjustPlayersOrder init range', r)
        setRange(r);
    }, []);
    const playerPos = (playerId) => positions.find((p) => p.id === playerId) || null;
    const playerPosNumber = (playerId) => { var _a; return ((_a = playerPos(playerId)) === null || _a === void 0 ? void 0 : _a.pos) || null; };
    const comparePositions = (p1, p2) => p1.pos - p2.pos;
    const getSortedPositionsArray = () => {
        const sortedPositions = [
            ...positions.sort((p1, p2) => comparePositions(p1, p2)),
        ];
        return sortedPositions.reduce((acc, p) => {
            acc.push(p.id);
            return acc;
        }, []);
    };
    const comparePlayers = (pId1, pId2) => {
        const pos1 = playerPosNumber(pId1);
        const pos2 = playerPosNumber(pId2);
        // console.log('AjustPlayersOrder, comparePlayers', pos1, pos2)
        if (pos1 && pos2)
            return pos1 - pos2;
        if (!pos1 && pos2)
            return 1;
        if (pos1 && !pos2)
            return -1;
        return 0;
    };
    const onPosChanged = (e) => {
        console.log(e);
        e.stopPropagation();
        setPosition(Number(e.target.value));
    };
    useEffect(() => {
        if (range.length > 0)
            setPosition(range[0]);
        // console.log('AjustPlayersOrder useEffect', range, position)
        setInnerPlayers([
            ...innerPlayers.sort((p1, p2) => comparePlayers(p1.id, p2.id)),
        ]);
    }, [range]);
    const removePosInRange = (p, r) => {
        r.splice(r.indexOf(p), 1);
        // console.log('AjustPlayersOrder removePosInRange', r, p)
        return r;
    };
    const addPosToRange = (p, r) => {
        if (!p)
            return r;
        const lRange = [...r, p].sort((r1, r2) => r1 - r2);
        // console.log('AjustPlayersOrder addPosToRange', lRange, p)
        return lRange;
    };
    const removePlayerPosition = (pos) => {
        if (!pos)
            return;
        positions.splice(positions.indexOf(pos), 1);
    };
    const onPlayerClick = (playerId) => {
        let lPositions;
        const currentPosition = position;
        let lRange = [...range];
        if (playerPos(playerId)) {
            lRange = addPosToRange(playerPosNumber(playerId), lRange);
            removePlayerPosition(playerPos(playerId));
            lPositions = [...positions];
            if (range.length > 0) {
                // console.log('AjustPlayersOrder onPlayerClick', currentPosition)
                lPositions = [...lPositions, { id: playerId, pos: currentPosition }];
                lRange = removePosInRange(currentPosition, lRange);
                // console.log('AjustPlayersOrder onPlayerClick', pos)
            }
        }
        else {
            lPositions = [...positions, { id: playerId, pos: position }];
            lRange = removePosInRange(position, lRange);
        }
        setPositions(lPositions || []);
        setRange(lRange);
    };
    const getSavePlayersOrderAction = (data) => function () {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield setPlayersOrder({ matchId, data });
            // console.log('AjustPlayersOrder onClickSave', response)
            setPlayersChanged(true);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        });
    };
    const onClickSave = () => __awaiter(this, void 0, void 0, function* () {
        if (range.length > 0) {
            setInfoAlert({
                message: "Порядковый номер присвоен не всем игрокам",
                type: "error",
                visible: true,
                setCancel: false,
            });
            return;
        }
        const data = getSortedPositionsArray();
        // console.log('AjustPlayersOrder onClickSave', getSortedPositionsArray())
        yield execAsyncAction({ action: getSavePlayersOrderAction(data) });
    });
    return (_jsxs(_Fragment, { children: [infoAlert.visible && (_jsx(AlertsNew, { message: infoAlert.message, type: infoAlert.type, setVisible: setInfoAlert, setCancel: infoAlert.setCancel })), _jsx(Box, Object.assign({ sx: commonModalStyles }, { children: _jsxs(Content, { children: [_jsx(Title, { children: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043F\u043E\u0440\u044F\u0434\u043A\u0430 \u0438\u0433\u0440\u043E\u043A\u043E\u0432" }), _jsx(Delimiter, { top: "30px" }), _jsxs(HeaderContainer, { children: [_jsxs(OrderHint, { children: ["\u041A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u043F\u043E \u0441\u0442\u0440\u043E\u043A\u0435 \u0438\u0433\u0440\u043E\u043A\u0430, \u0438 \u043E\u043D \u0431\u0443\u0434\u0435\u0442", _jsx("br", {}), "\u0432 \u0441\u043F\u0438\u0441\u043A\u0435 \u043F\u043E\u0434 \u043D\u043E\u043C\u0435\u0440\u043E\u043C"] }), _jsx(Delimiter, { right: "62px" }), _jsxs(InputWrapper, { children: [_jsx(Input, Object.assign({ as: "select", name: "position", value: position, onChange: onPosChanged }, { children: range.map((p) => (_jsx("option", Object.assign({ value: p }, { children: p }), p))) })), _jsx(Label, Object.assign({ htmlFor: "position" }, { children: "\u041F\u043E\u0440\u044F\u0434\u043A\u043E\u0432\u044B\u0439 \u043D\u043E\u043C\u0435\u0440" }))] })] }), _jsx(Delimiter, { top: "40px" }), _jsx(TableContainer, Object.assign({ sx: { overflow: "auto" } }, { children: _jsxs(Table, Object.assign({ "aria-label": "customized table" }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u2116" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0418\u043C\u044F" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0418\u0433\u0440\u043E\u0432\u043E\u0435 \u0438\u043C\u044F" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u041A\u043E\u043B-\u0432\u043E \u0438\u0433\u0440" }))] }) }), _jsx(TableBody, { children: innerPlayers.map((player) => (_jsxs(TableRow, Object.assign({ onClick: () => onPlayerClick(player.id), hover: true }, { children: [_jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: playerPosNumber(player.id) || "" })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: player.player.realName })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: player.player.gameName })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: player.player.gamesCount }))] }), player.id))) })] })) })), _jsx(Delimiter, { top: "20px" }), _jsx(Button, Object.assign({ size: "large", variant: "contained", sx: { width: "220px", alignSelf: "center" }, onClick: () => onClickSave() }, { children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }))] }) }))] }));
}
